import axios from "axios";
import { WAREHOUSE_URL, STORAGES_URL, CHANNEL_URL, GET_STATE_URL, GET_CITY_URL } from "../../../../../constants/config";
import { initialFilter } from "../../pages/purchase-orders/PurchaseOrdersUIHelpers";
import { REPLACE_TO_DEFAULT_QUERY_PARAMS } from "../../../Common/utils";

// CREATE =>  POST: add a new warehouse to the server
export function createWarehouse(warehouse) {
  return axios.post(CHANNEL_URL, warehouse);
}

// READ
export function getAllWarehouses() {
  return axios.get(`${WAREHOUSE_URL}/list`);
}

export function getWarehouseById(warehouseId) {
  return axios.get(`${WAREHOUSE_URL}/${warehouseId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findWarehouse(queryParams) {
  // console.log("🚀 ~ file: warehousesCrud.js ~ line 23 ~ findWarehouse ~ queryParams", queryParams);
  queryParams = queryParams === undefined ? initialFilter : REPLACE_TO_DEFAULT_QUERY_PARAMS(queryParams, initialFilter);
  queryParams.channel_type = 0;
  queryParams.pageSize = queryParams.page_size;
  queryParams.page = 1;
  queryParams.search_key = queryParams.searchKey || "";
  queryParams.sort_field = queryParams.sortField || "";
  return axios.get(
    // `${WAREHOUSE_URL}/list?search_key=${queryParams.search_key}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}`
    `${CHANNEL_URL}/list`,
    { params: queryParams }
  );
}

export function findChannels(params) {
  return axios.get(`${CHANNEL_URL}/list`, { params });
}

export function findStorage(queryParams) {
  // console.log("🚀 ~ file: warehousesCrud.js ~ line 23 ~ findWarehouse ~ queryParams", queryParams);
  queryParams = queryParams === undefined ? initialFilter : REPLACE_TO_DEFAULT_QUERY_PARAMS(queryParams, initialFilter);
  // console.log("🚀 ~ file: warehousesCrud.js ~ line 25 ~ findWarehouse ~ queryParams", queryParams);
  return axios.get(
    // `${WAREHOUSE_URL}/list?search_key=${queryParams.search_key}&page=${queryParams.pageNumber}&page_size=${queryParams.pageSize}`
    // `${WAREHOUSE_URL}/list`,
    `${STORAGES_URL}/list?search_key=${queryParams.search_key}`
    // { params: queryParams }
  );
}

// UPDATE => PUT: update the procuct on the server
export function updateWarehouse(id, warehouse) {
  return axios.put(`${CHANNEL_URL}/${id}`, warehouse);
}

export function patchWarehouse(id) {
  return axios.patch(`${CHANNEL_URL}/${id}/set_primary`);
}

// UPDATE Status
export function updateStatusForWarehouses(ids, status) {
  return axios.post(`${WAREHOUSE_URL}/updateStatusForWarehouses`, {
    ids,
    status,
  });
}

// DELETE => delete the warehouse from the server
export function deleteWarehouse(warehouseId) {
  return axios.delete(`${CHANNEL_URL}/${warehouseId}`);
}

// DELETE Warehouses by ids
export function deleteWarehouses(ids) {
  return axios.post(`${CHANNEL_URL}/deleteWarehouses`, { ids });
}

export function getCities(params) {
  return axios.get(`${GET_CITY_URL}`, { params });
}

export function getStates(params) {
  return axios.get(`${GET_STATE_URL}`, { params });
}
